module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("Search for interactions. Toggle advanced seach to do an advanced search")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-form', {
    ref: "form",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSimpleSearch($event)
      }
    }
  }, [(!_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "simple"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Search....",
      "name": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSimpleSearch($event)
      }
    },
    model: {
      value: (_vm.currentSearchTerm),
      callback: function($$v) {
        _vm.currentSearchTerm = $$v
      },
      expression: "currentSearchTerm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleSimpleSearch
    }
  }, [_vm._v("Search")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "advanced"
  }, [_c('advanced-search-form', {
    attrs: {
      "search-fields": _vm.searchFields
    },
    on: {
      "onSearch": _vm.handleAdvancedSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "block",
      "padding-top": "10px"
    },
    attrs: {
      "active-color": "#683090",
      "inactive-color": "#683090",
      "active-text": "Advanced",
      "inactive-text": "Simple"
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  })], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: {
      'fixed-container': true
    }
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title",
    style: ({
      'border-top': "2px solid #ee2465"
    })
  }, [_c('h5', [(!_vm.searching) ? _c('span', [_vm._v(_vm._s(_vm.searchCount.toLocaleString()) + " results found.")]) : _vm._e(), _vm._v(" "), (_vm.searching) ? _c('span', [_vm._v("Searching...")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [(_vm.searchCount > 0) ? _c('el-tooltip', {
    attrs: {
      "content": "Export to Excel",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.toggleDownload
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.searchCount > 0 && _vm.showPanelDownload) ? _c('div', {
    staticClass: "panel-download"
  }, [_c('el-input', {
    staticStyle: {
      "margin": "5px auto"
    },
    attrs: {
      "placeholder": "File name",
      "size": "mini"
    },
    model: {
      value: (_vm.filename),
      callback: function($$v) {
        _vm.filename = $$v
      },
      expression: "filename"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.filename),
      expression: "!!filename"
    }],
    staticClass: "fa fa-times el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    on: {
      "click": _vm.clearFileNameInput
    },
    slot: "prefix"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.filename),
      expression: "!filename"
    }],
    staticClass: "el-icon-download el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": _vm.filename.length < 1,
      "icon": "fa fa-download"
    },
    on: {
      "click": function($event) {
        return _vm.exportToFile(_vm.filename)
      }
    },
    slot: "append"
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("Interactions search results")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content content-style",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: 'content',
    staticClass: "ibox-content content-style",
    attrs: {
      "settings": _vm.scrollBarSettings
    }
  }, _vm._l((_vm.searchResults), function(interaction) {
    return _c('div', {
      key: interaction.id,
      staticClass: "search-results"
    }, [_c('div', {
      staticClass: "search-result"
    }, [_c('interaction', {
      attrs: {
        "interaction": interaction
      }
    })], 1)])
  }), 0)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Search")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f80f59f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/SearchResults.vue
// module id = 3355
// module chunks = 3